export const offerSupportLenders = {
  401: { lenderId: 401, logo: 'https://iccdn.in/img/kotak-icon-v1.png' },
  701: {
    lenderId: 701,
    logo: 'https://iccdn.in/lenders/icici-icon-logo-v4.svg',
  },
  501: {
    lenderId: 501,
    logo: 'https://iccdn.in/img/hdfc-logo-icon-v2.png',
  },
  201: {
    lenderId: 201,
    logo: 'https://iccdn.in/img/idfc-first-icon-v1.png',
  },
};

export const bigCOfferLenders = {
  401: true,
  701: true,
  501: true,
  201: true,
};

export const lotMobilesOfferLenders = {
  401: true,
  701: true,
  501: true,
  201: true,
};

export const sangeethaOfferLenders = {
  401: true,
  701: true,
  501: true,
  201: true,
};



// WEBPACK FOOTER //
// ./constants/offerSupportLenders.js